var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _line, _path4, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 182,
    viewBox: "0 0 216 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 211.008,
    height: 125.697,
    rx: 11.0181,
    transform: "matrix(1 0 0 -1 4.99219 132.097)",
    fill: "#8A99A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 103.962L216.001 103.962V17.4174C216.001 11.3323 211.068 6.39937 204.983 6.39937L16.0103 6.39937C9.92516 6.39937 4.99219 11.3323 4.99219 17.4174L4.99219 103.962Z",
    fill: "#FFE3E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.37726,
    y: -1.37726,
    width: 208.254,
    height: 122.943,
    rx: 9.64081,
    transform: "matrix(1 0 0 -1 0 123.443)",
    stroke: "#153243",
    strokeWidth: 2.75452
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6406,
    y: 167.491,
    width: 116.168,
    height: 14.0672,
    rx: 5.50903,
    fill: "#8A99A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.238 129.375H93.4865C92.2711 129.375 91.1994 130.171 90.849 131.335L79.4141 169.307H141.809L130.238 129.375Z",
    fill: "#8A99A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.652386,
    y: -0.652386,
    width: 9.44269,
    height: 2.77926,
    rx: 1.38963,
    transform: "matrix(1 0 0 -1 13.1602 17.3456)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.30477
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.652386,
    y: -0.652386,
    width: 9.44269,
    height: 2.77926,
    rx: 1.38963,
    transform: "matrix(1 0 0 -1 27.5625 17.3456)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.30477
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.652386,
    y: -0.652386,
    width: 9.44269,
    height: 2.77926,
    rx: 1.38963,
    transform: "matrix(1 0 0 -1 41.9648 17.3456)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.30477
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.48801,
    y: -0.126588,
    width: 15.2844,
    height: 4.49865,
    rx: 2.24932,
    transform: "matrix(0.7645 0.644623 0.644623 -0.7645 70.9359 44.9732)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 2.11196
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0231582,
    y: -1.4932,
    width: 15.2844,
    height: 4.49865,
    rx: 2.24932,
    transform: "matrix(0.717987 -0.696056 -0.696056 -0.717987 74.3422 54.7399)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 2.11196
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.48801,
    y: -0.126588,
    width: 15.2844,
    height: 4.49865,
    rx: 2.24932,
    transform: "matrix(0.7645 0.644623 0.644623 -0.7645 123.823 44.9732)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 2.11196
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0231582,
    y: -1.4932,
    width: 15.2844,
    height: 4.49865,
    rx: 2.24932,
    transform: "matrix(0.717987 -0.696056 -0.696056 -0.717987 127.229 54.7399)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 2.11196
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0664 88.0802L69.3214 87.0045C72.2668 84.4799 76.4133 83.9036 79.9356 85.5292L81.7647 86.3734C84.0335 87.4206 86.6982 87.1048 88.6595 85.5564V85.5564C90.7327 83.9197 93.579 83.6679 95.9073 84.9152L97.4526 85.7431C100.162 87.1945 103.432 87.1293 106.081 85.5708L106.423 85.3696C109.044 83.8281 112.304 83.8719 114.882 85.4832V85.4832C117.44 87.0815 120.67 87.1385 123.282 85.6316L124.015 85.2089C126.523 83.762 129.621 83.8024 132.09 85.3142V85.3142C134.823 86.9876 138.297 86.8446 140.883 84.9521L143.741 82.8613",
    stroke: "#153243",
    strokeWidth: 6.42491
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 104.853,
    x2: 211.008,
    y2: 104.853,
    stroke: "#153243",
    strokeWidth: 2.75452
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.245 125.29H88.4943C87.2789 125.29 86.2072 126.087 85.8568 127.25L74.4219 165.223H136.817L125.245 125.29Z",
    stroke: "#153243",
    strokeWidth: 2.75452
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0257,
    y: 165.692,
    width: 113.414,
    height: 11.3127,
    rx: 4.13178,
    stroke: "#153243",
    strokeWidth: 2.75452
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionError);
export default __webpack_public_path__ + "static/media/transaction-error.91d1a639.svg";
export { ForwardRef as ReactComponent };